import { type FC, type ReactNode } from "react";
import { DialogTitle, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  icon: ReactNode;
  title: string;
  onClose: () => void;
}

const ClientDialogTitle: FC<Props> = ({ icon, title, onClose }) => (
  <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      {icon}
      <span>{title}</span>
    </Stack>
    <IconButton size="small" onClick={onClose}>
      <CloseIcon fontSize="small" />
    </IconButton>
  </DialogTitle>
);

export default ClientDialogTitle;
